module.exports = __webpack_public_path__ + "static/img/manual3.88dca92c.png";